import React from "react";
import EventItemCard from "./EventItemCard";

function FinancialNewsEvents({
  title = "Trending Events",
  events = [],
  isLoading = false,
  onEventClick,
  onSeeAllClick,
}) {
  if (!isLoading && (!events || events.length === 0)) {
    return null;
  }

  return (
    <div className="standard-container financial-news-events-card">
      <div
        className="guardian-section-header"
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          marginBottom: "12px",
        }}
      >
        <h4 className="padding-reset margin-reset">{title}</h4>

        {onSeeAllClick && (
          <button
            type="button"
            className="cta-button secondary rounded small btn-fit-content"
            onClick={onSeeAllClick}
            style={{
              fontSize: "12px",
              padding: "4px 10px",
              fontWeight: 600,
            }}
          >
            SEE ALL
          </button>
        )}
      </div>

      <div className="rules-list-group" style={{ margin: "0" }}>
        {events.map((eventItem, index) => {
          const isLast = index === events.length - 1;
          const eventKey =
            eventItem.uuid || eventItem.external_event_id || `event-${index}`;

          return (
            <EventItemCard
              key={eventKey}
              eventItem={eventItem}
              isLast={isLast}
              onEventClick={onEventClick}
            />
          );
        })}
      </div>
    </div>
  );
}

export default FinancialNewsEvents;
